import React from "react";

import SuggestionTitle from "./SuggestionTitle";
import CardMap, { Up } from "./CardMap";
import { ISuggestion, SuggestionListProps } from "./type";
import { useHandleRoutes } from "@hooks";
import { formatCurrency, formatStayTimeToSeconds, formatTimeToSeconds, formatTitleStrategy } from "@utils";
import { IStop } from "src/components/RegisterRoute";

  export const formatHours = (totalSeconds: number) => {
    if (typeof totalSeconds !== "number" || totalSeconds < 0 || isNaN(totalSeconds)) {
      return "0h 0min 0s";
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}h${minutes}m${seconds}s`;
  };

const SuggestionList: React.FC<SuggestionListProps> = ({ suggestions, onSelectSuggestion, onSkip, onBack, isEdit, label, isCreatingTrip, routeData, primary }) => {
  const { handleRoutes } = useHandleRoutes();

  const getFieldStatus = (field1: number, field2: number) => {
    if (field1 === field2) {
      return 'ECQUAL'
    }

    if (field1 < field2) {
      return 'UP'
    }

    return 'DOWN'
  }

  return (
    <div>
      <div className="display-flex flex-column">

        <div className="display-block width-100pct">
          {suggestions?.map((suggestion, index) => {
            // Extrai os dados do novo formato
            const title = formatTitleStrategy(suggestion.strategy);

            let subtitle = suggestion.route_highlight_label || "(Não há diferença da rota primária)";
            subtitle = subtitle.replace(/R\$ (\d+)\.(\d{2})/, (match, reais, centavos) => {
              return `R$ ${reais},${centavos}`;
            });

            const matchMinutes = RegExp(/\((\d+)\s+minutos/).exec(subtitle);
            if (matchMinutes) {
              const totalMinutes = parseInt(matchMinutes[1], 10);
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;
              const formatted = `${hours}h${minutes.toString().padStart(2, '0')}min`;
              subtitle = subtitle.replace(/\(\d+\s+minutos/, `(${formatted}`);
            }

            const totalStayTime = routeData?.stops?.reduce((total: number, stop: IStop) => {
              return total + formatStayTimeToSeconds(stop.stayTime);
            }, 0);

            const calcDuration = suggestion.completed_route?.travelSummary?.duration + totalStayTime
            const duration = formatHours(calcDuration || 0);

            const distance = suggestion.completed_route?.travelSummary?.length
              ? `${(suggestion.completed_route.travelSummary.length / 1000)?.toFixed(2)?.replace(/\./g, ',')}km`
              : "";

            const { segments, boundingBox, markers } = handleRoutes(suggestion.completed_route?.routes, []);
            let bounding = boundingBox;

            if (boundingBox) {
              const padding = 80;

              bounding = {
                top: boundingBox?.top + padding,
                bottom: boundingBox.bottom + padding,
                left: boundingBox.left + padding,
                right: boundingBox.right + padding
              }
            }

            const routeSegments = segments.length ? [{ points: segments, alternative: false }] : [];

            const zoom = 9;

            let position = { lat: 0, lng: 0 };
            if (segments.length > 0) {
              const latSum = segments.reduce((acc, p) => acc + Number(p.lat), 0);
              const lngSum = segments.reduce((acc, p) => acc + Number(p.lng), 0);
              position = {
                lat: latSum / segments.length,
                lng: lngSum / segments.length,
              };
            }
            const estimated_consumption = suggestion.estimated_consumption ? `${suggestion?.estimated_consumption?.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + ' ' + label}` : `0${label}`
            const totalCost = suggestion?.total_cost ? `${formatCurrency(suggestion?.total_cost)}` : 'R$ 0,00';

            const payload = {
              ...suggestion,
              duration: calcDuration,
              completed_route: {
                ...suggestion.completed_route,
                summary: {
                  ...suggestion.completed_route?.summary,
                  duration: calcDuration,
                },
                travelSummary: {
                  ...suggestion.completed_route?.travelSummary,
                  duration: calcDuration,
                }
              }
            }
            const d = suggestion?.completed_route?.travelSummary?.length ? suggestion.completed_route.travelSummary.length : 0;
            const dp = primary?.distance ? primary?.distance : '0';
            const ec = suggestion?.estimated_consumption ? suggestion?.estimated_consumption : 0;

            const distanceSuggestion = parseFloat((d / 1000).toFixed(2));
            const distancePrimary = parseFloat(dp);
            const durationPrimary = primary?.duration ? primary?.duration: 0;
            const estimatedPrimary = primary?.estimatedConsumption ? primary?.estimatedConsumption : 0;
            const totalCostPrimary = primary?.totalCost ? primary?.totalCost : 0;

            console.log({ c: calcDuration, durationPrimary })

            const isUp: Up = {
              distance: getFieldStatus(distanceSuggestion, distancePrimary),
              duration: getFieldStatus(suggestion.completed_route?.travelSummary?.duration + totalStayTime, durationPrimary),
              estimated_consumption: getFieldStatus(ec, estimatedPrimary),
              totalCost: getFieldStatus(suggestion?.total_cost, totalCostPrimary),
            }

            return (
              <div key={index} className="display-inline-block width-50pct padding-20">
                <SuggestionTitle title={title} subtitle={subtitle} />
                <div className="margin-top-10">
                  <CardMap
                    duration={duration}
                    distance={distance}
                    segments={routeSegments}
                    markers={markers}
                    zoom={zoom}
                    position={position}
                    onSelect={() => onSelectSuggestion(payload as ISuggestion)}
                    boundingBox={bounding}
                    totalCost={totalCost}
                    estimated_consumption={estimated_consumption}
                    isDisabled={isCreatingTrip}
                    isUp={isUp}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SuggestionList;

